"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfListProfileDto = instanceOfPaginatedResponseOfListProfileDto;
exports.PaginatedResponseOfListProfileDtoFromJSON = PaginatedResponseOfListProfileDtoFromJSON;
exports.PaginatedResponseOfListProfileDtoFromJSONTyped = PaginatedResponseOfListProfileDtoFromJSONTyped;
exports.PaginatedResponseOfListProfileDtoToJSON = PaginatedResponseOfListProfileDtoToJSON;
exports.PaginatedResponseOfListProfileDtoToJSONTyped = PaginatedResponseOfListProfileDtoToJSONTyped;
const PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1 = require("./PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta");
const ListProfileDto_1 = require("./ListProfileDto");
/**
 * Check if a given object implements the PaginatedResponseOfListProfileDto interface.
 */
function instanceOfPaginatedResponseOfListProfileDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfListProfileDtoFromJSON(json) {
    return PaginatedResponseOfListProfileDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfListProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(ListProfileDto_1.ListProfileDtoFromJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfListProfileDtoToJSON(json) {
    return PaginatedResponseOfListProfileDtoToJSONTyped(json, false);
}
function PaginatedResponseOfListProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(ListProfileDto_1.ListProfileDtoToJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfListProfileDto.js.map